// extracted by mini-css-extract-plugin
export default {"block":"YgEDC9IgO2zJP6gjZIWW","errorIcon":"QGBjhdNnRpuHqLgsxXmH","title":"WWvaYJQMKvJKVhtYBBtX","description":"f_yw_smjyOX3Adx37u_R"};